import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'typeInput',
    'correctInput',
    'choiceCheckbox',
    'completeAnswerLabel',
    'completeAnswerClearButton',
    'descriptionAnswerInput'
  ];

  connect() {
    this.setCorrect();
  }

  setCorrect() {
    switch (this.typeInputTarget.value) {
      case 'no_particular_order_test':
        this.correctInputTarget.value = this.choiceCheckboxTargets.filter(t => t.checked).map(t => t.value).join('/');
        break;
      case 'description_test':
        this.correctInputTarget.value = this.descriptionAnswerInputTargets.filter(t => t.value.length > 0).map(t => t.value).join('/');
        break;
    }
  }

  pickCompleteAnswer(event) {
    const correct = this.correctInputTarget.value;
    const answers = correct.length > 0 ? correct.split('/') : [];

    answers.push(event.target.value);

    this.correctInputTarget.value = answers.join('/');
    this.completeAnswerLabelTarget.innerHTML = this.correctInputTarget.value;
    this.completeAnswerClearButtonTarget.hidden = false;
  }

  clearCompleteAnswers() {
    this.correctInputTarget.value = '';
    this.completeAnswerLabelTarget.innerHTML = '選択してください';
    this.completeAnswerClearButtonTarget.hidden = true;
  }
}
